import { ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const currentLayout = window.$environment.CURRENT_LAYOUT;
const baseUrl = currentLayout === 'SpireonNew' ? '/spireon' : '';

const leftMenu = [
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.summary',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/summary',
  },
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.logs',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/logs',
  },
  {
    icon: mediaUrls.user,
    label: 'Drivers Status',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/driverStatus/more',
  },
  {
    icon: mediaUrls.user,
    label: 'leftMenu.users',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/user/all',
  },
  {
    icon: mediaUrls.vehicle,
    label: 'leftMenu.vehicles',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/vehicle/list',
  },
  {
    icon: mediaUrls.accident,
    label: 'leftMenu.accidents',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/accidents/list',
  },
  {
    icon: mediaUrls.inspections,
    label: 'leftMenu.inspections',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/inspections',
  },
  {
    icon: mediaUrls.reports,
    label: 'leftMenu.reports',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/report',
  },
  {
    icon: mediaUrls.policy,
    label: 'leftMenu.policiesProcedures',
    roles: ['FLMANAGER', 'ADMIN', ROLES.VIEW_ONLY_FM],
    path: baseUrl + '/policy',
  },
  {
    icon: mediaUrls.logout,
    label: 'avatarMenu.logout',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER', 'MECHANIC', ROLES.VIEW_ONLY_FM],
    path: '#',
    action: 'logout',
  },
];

export default leftMenu;
